export default __webpack_public_path__ + "static/media/upload.ba7539ca.svg";